import React, { useEffect, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { ServerRequestProtected } from "../../../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../../../utils/NotificationHandler"
import Loader from "../../../../../shared/Loader/Loader"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { enumUtil } from "../../../../../../utils/Enum";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import EligiblityHistoryStatusTabs from "./EligibilityHistoryStatusTabs";
import CustomUseRef from "../../../../../shared/DropDown/CustomUseRef";
import isNull from "../../../../../../utils/NullChecking";
import { useSelector } from "react-redux";

const EligiblityHistoryStatus = ({ setReloadGrid, setShowEligibilityHistory, id, type, ListOfID }) => {

  console.log(ListOfID, 'ListOfID');
  let DropDowns = useSelector(state => state.GeneralDropDownsReducer);

  const TabsMenu_model = [
    {
      name: "General",
      key: 1,
      icon: "",
      right: true,
    },
    {
      name: "Active",
      key: 2,
      icon: "",
      right: true,
    },
    {
      name: "Co-Insurance",
      key: 3,
      icon: "",
      right: true,
    },
    {
      name: "Co-Payment",
      key: 4,
      icon: "",
      right: true,
    },
    {
      name: "Deductible",
      key: 5,
      icon: "",
      right: true,
    },
    {
      name: "Benefit Description",
      key: 11,
      icon: "",
      right: true,
    },
    {
      name: "Out of Pocket",
      key: 6,
      icon: "",
      right: true,
    },
    {
      name: "Limitations",
      key: 7,
      icon: "",
      right: true,
    },
    {
      name: "Others",
      key: 8,
      icon: "",
      right: true,
    },

    // "Benefit Description
  ];
  const [isRecordSaved, setIsRecordSaved] = useState(false)
  const API_URL = enumUtil.controller.Eligibility
  const API_GENERAL = enumUtil.controller.General;
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [errorMessage, setErrorMessage] = useState({});
  const [eligibilityHistoryData, setEligibilityHistoryData] = useState()
  const [inActiveTabShow, setInActiveTabShow] = useState(false)
  const [nonCoveredTabShow, setNonCoveverdTabShow] = useState(false)

  const [TabsMenu, setTabsMenu] = useState(TabsMenu_model)
  // const [currentIndex, setCurrentIndex] = useState(ListOfID.indexOf(id));
  const [currentID, setCurrentID] = useState(() => {
    return id ?? ListOfID[0];
  });
  const currentIndex = ListOfID?.indexOf(currentID);


  const TabCol = [
    "Coverage Level",
    "Services",
    "Insurance Type",
    "Plan Description",
    "Time Period",
    "Amount/Perc.",
    "Quantity",
    "Quan. Value",
    "Plan Network",
    "Auth/Cert",
  ];

  const LoadData = (ID) => {
    if (ID !== null) {
      setIsLoading(true)
      isRecordSaved && setReloadGrid(true);
      setIsRecordSaved(false)
      setEligibilityHistoryData([])
      ServerRequestProtected(API_URL + "/GetEligibilityData", 'post', {
        "TableName": enumUtil.enumAPITableName.EligibilityData,
        "ParentID": ID + "",
      }).then((response) => {

        const hasInactive = response?.Data?.[0]?.ChildData?.some(item => item.CovergeType === "Inactive");
        const hasNonCover = response?.Data?.[0]?.ChildData?.some(item => item.CovergeType === "Non-Covered");
        const Active_Pending = response?.Data?.[0]?.ChildData?.some(item => item.CovergeType === "Active - Pending Investigation");
        const Primary_Care = response?.Data?.[0]?.ChildData?.some(item => item.CovergeType === "Primary Care Provider");
        const AdditionalPayor = response?.Data?.[0]?.ChildData?.some(item => item.CovergeType === "Other or Additional Payor");


        if (hasInactive) {
          const inactiveTab = {
            name: "In Active",
            key: 9,
            icon: "",
            right: true,
          };
          setTabsMenu((prevTabs) => {
            const isAlreadyAdded = prevTabs.some((tab) => tab.key === 9);
            if (!isAlreadyAdded) {
              const newTabs = [...prevTabs];
              newTabs.splice(2, 0, inactiveTab);
              return newTabs;
            }
            return prevTabs;
          });

        }
        if (Active_Pending) {
          const Activepending = {
            name: "Active-Pending-Investigation",
            key: 12,
            icon: "",
            right: true,
          };
          setTabsMenu((prevTabs) => {
            const isAlreadyAdded = prevTabs.some((tab) => tab.key === 12);
            if (!isAlreadyAdded) {
              const newTabs = [...prevTabs];

              newTabs.splice(hasInactive ? 3 : 2, 0, Activepending);
              return newTabs;
            }
            return prevTabs;
          });
        }

        if (hasNonCover) {
          const nocoverTab = {
            name: "Not-Covered",
            key: 10,
            icon: "",
            right: true,
          };
          setTabsMenu((prevTabs) => {
            const isAlreadyAdded = prevTabs.some((tab) => tab.key === 10);
            if (!isAlreadyAdded) {
              const newTabs = [...prevTabs];

              newTabs.splice(hasInactive && Active_Pending ? 4 : hasInactive && Active_Pending ? 3 : 2, 0, nocoverTab);
              return newTabs;
            }
            return prevTabs;
          });
        }
        // if (Primary_Care) {
        //   const PrimaryCareTab = {
        //     name: "Primary Care",
        //     key: 13,
        //     icon: "",
        //     right: true,
        //   };
        //   setTabsMenu((prevTabs) => {
        //     const alreadyExists = prevTabs.some(tab => tab.key === 13);
        //     if (!alreadyExists) {
        //       return [...prevTabs, PrimaryCareTab];
        //     }
        //     return prevTabs;
        //   });
        // }
        if (Primary_Care) {
          const PrimaryCareTab = {
            name: "Primary-Care-Provider",
            key: 13,
            icon: "",
            right: true,
          };
          setTabsMenu((prevTabs) => {
            const alreadyExists = prevTabs.some(tab => tab.key === 13);
            if (!alreadyExists) {
              const othersIndex = prevTabs.findIndex(tab => tab.name === "Others");
              if (othersIndex !== -1) {
                const newTabs = [...prevTabs];
                newTabs.splice(othersIndex, 0, PrimaryCareTab);
                return newTabs;
              } else {
                return [...prevTabs, PrimaryCareTab];
              }
            }
            return prevTabs;
          });
        }

        if (AdditionalPayor) {
          const AdditionalPayorTab = {
            name: "Additional Payor",
            key: 14,
            icon: "",
            right: true,
          };

          setTabsMenu((prevTabs) => {
            const alreadyExists = prevTabs.some(tab => tab.key === 14);
            if (alreadyExists) return prevTabs;

            const newTabs = [...prevTabs];

            const primaryCareIndex = newTabs.findIndex(tab => tab.name === "Primary Care");
            const othersIndex = newTabs.findIndex(tab => tab.name === "Others");

            if (primaryCareIndex !== -1) {
              newTabs.splice(primaryCareIndex + 1, 0, AdditionalPayorTab);
            } else if (othersIndex !== -1) {
              newTabs.splice(othersIndex, 0, AdditionalPayorTab);
            } else {
              newTabs.push(AdditionalPayorTab);
            }

            return newTabs;
          });
        }
        setIsLoading(false)
        setEligibilityHistoryData(response);
      }).catch((error) => {
        setInActiveTabShow(false)
        setNonCoveverdTabShow(false)

        setIsLoading(false)
        NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
      })
    }
  }
  const LoadInstantData = (ID) => {
    if (ID !== null) {
      setIsLoading(true)
      isRecordSaved && setReloadGrid(true);
      setIsRecordSaved(false)
      setEligibilityHistoryData([])
      ServerRequestProtected(API_URL + "/GetEligibilityData", 'post', {
        "TableName": enumUtil.enumAPITableName.InstantEligibility,
        "ParentID": ID + "",
      }).then((response) => {

        const hasInactive = response?.Data?.[0]?.ChildData?.some(item => item.CovergeType === "Inactive");
        const hasNonCover = response?.Data?.[0]?.ChildData?.some(item => item.CovergeType === "Non-Covered");
        const Active_Pending = response?.Data?.[0]?.ChildData?.some(item => item.CovergeType === "Active - Pending Investigation");
        const Primary_Care = response?.Data?.[0]?.ChildData?.some(item => item.CovergeType === "Primary Care Provider");
        const AdditionalPayor = response?.Data?.[0]?.ChildData?.some(item => item.CovergeType === "Other or Additional Payor");


        if (hasInactive) {
          const inactiveTab = {
            name: "In Active",
            key: 9,
            icon: "",
            right: true,
          };
          setTabsMenu((prevTabs) => {
            const isAlreadyAdded = prevTabs.some((tab) => tab.key === 9);
            if (!isAlreadyAdded) {
              const newTabs = [...prevTabs];
              newTabs.splice(2, 0, inactiveTab);
              return newTabs;
            }
            return prevTabs;
          });

        }
        if (Active_Pending) {
          const Activepending = {
            name: "Active-Pending-Investigation",
            key: 12,
            icon: "",
            right: true,
          };
          setTabsMenu((prevTabs) => {
            const isAlreadyAdded = prevTabs.some((tab) => tab.key === 12);
            if (!isAlreadyAdded) {
              const newTabs = [...prevTabs];

              newTabs.splice(hasInactive ? 3 : 2, 0, Activepending);
              return newTabs;
            }
            return prevTabs;
          });
        }

        if (hasNonCover) {
          const nocoverTab = {
            name: "Not-Covered",
            key: 10,
            icon: "",
            right: true,
          };
          setTabsMenu((prevTabs) => {
            const isAlreadyAdded = prevTabs.some((tab) => tab.key === 10);
            if (!isAlreadyAdded) {
              const newTabs = [...prevTabs];

              newTabs.splice(hasInactive && Active_Pending ? 4 : hasInactive && Active_Pending ? 3 : 2, 0, nocoverTab);
              return newTabs;
            }
            return prevTabs;
          });
        }
        // if (Primary_Care) {
        //   const PrimaryCareTab = {
        //     name: "Primary Care",
        //     key: 13,
        //     icon: "",
        //     right: true,
        //   };
        //   setTabsMenu((prevTabs) => {
        //     const alreadyExists = prevTabs.some(tab => tab.key === 13);
        //     if (!alreadyExists) {
        //       return [...prevTabs, PrimaryCareTab];
        //     }
        //     return prevTabs;
        //   });
        // }
        if (Primary_Care) {
          const PrimaryCareTab = {
            name: "Primary-Care-Provider",
            key: 13,
            icon: "",
            right: true,
          };
          setTabsMenu((prevTabs) => {
            const alreadyExists = prevTabs.some(tab => tab.key === 13);
            if (!alreadyExists) {
              const othersIndex = prevTabs.findIndex(tab => tab.name === "Others");
              if (othersIndex !== -1) {
                const newTabs = [...prevTabs];
                newTabs.splice(othersIndex, 0, PrimaryCareTab);
                return newTabs;
              } else {
                return [...prevTabs, PrimaryCareTab];
              }
            }
            return prevTabs;
          });
        }

        if (AdditionalPayor) {
          const AdditionalPayorTab = {
            name: "Additional Payor",
            key: 14,
            icon: "",
            right: true,
          };

          setTabsMenu((prevTabs) => {
            const alreadyExists = prevTabs.some(tab => tab.key === 14);
            if (alreadyExists) return prevTabs;

            const newTabs = [...prevTabs];

            const primaryCareIndex = newTabs.findIndex(tab => tab.name === "Primary Care");
            const othersIndex = newTabs.findIndex(tab => tab.name === "Others");

            if (primaryCareIndex !== -1) {
              newTabs.splice(primaryCareIndex + 1, 0, AdditionalPayorTab);
            } else if (othersIndex !== -1) {
              newTabs.splice(othersIndex, 0, AdditionalPayorTab);
            } else {
              newTabs.push(AdditionalPayorTab);
            }

            return newTabs;
          });
        }
        setIsLoading(false)
        setEligibilityHistoryData(response);
      }).catch((error) => {
        setInActiveTabShow(false)
        setNonCoveverdTabShow(false)

        setIsLoading(false)
        NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
      })
    }
  }

  // useEffect(() => {
  //   LoadData(id);
  // }, [isRecordSaved])

  useEffect(() => {
    if (type === 'InstantEligibility') {
      LoadInstantData(id);
    } else {
      LoadData(id);
    }
  }, [isRecordSaved])

  useEffect(() => {
    console.log("eligibilityHistoryData", eligibilityHistoryData, "ChildData", eligibilityHistoryData?.Data?.[0]?.ChildData)
    eligibilityHistoryData?.Data ? console.log("eligibilityHistoryData", eligibilityHistoryData.Data[0]) : console.log("eligibi",)
  }, [eligibilityHistoryData])
  const handleActiveTab = (item) => {
    setActiveTab(item.key);
  };
  // console.log(TabsMenu, 'TabsMenu');
  useEffect(() => {

    if (currentID && type !== 'InstantEligibility') {
      LoadData(currentID);
    }
  }, [currentID]);
  const handlePrevious = () => {
    let curr = currentIndex - ""
    if (curr > 0) {
      const prevID = ListOfID[curr - 1];
      setCurrentID(prevID); // API automatically useEffect se call hogi
      currentIndex = curr - 1
    }
  };
  const handleNext = () => {
    let curr = currentIndex - ""
    if (curr < ListOfID.length - 1) {
      const nextID = ListOfID[curr + 1];
      setCurrentID(nextID); // API automatically useEffect se call hogi
      currentIndex = curr + 1
    }
  };

  const handleCreatePatient = () => {
    setIsLoading(true)
    ServerRequestProtected(API_GENERAL + "/SaveSingleRecord", 'post', {
      "TableName": enumUtil.enumAPITableName.InstantEligibility,
      "ID": id + "",
      "Data": {
        "LocationID": DropDowns?.Location.length > 0 ? DropDowns?.Location?.[1]?.value + "" : '0',
      }
    }).then((response) => {
      setIsLoading(false)
      NotificationHandler('Patient created successfully', enumUtil.enumtoaster.success);
    }).catch((error) => {
      setIsLoading(false)
      NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
    })
  }


  return (
    <div className="h-100 hk-claims-tabs hk-eligibility-tabs mt-2">
      {isLoading ? <Loader /> : null}
      <div className="d-flex hk-flex eligibilty_his_screen h-100 overflow-visible">
        <div className="tab-menu-sidebar">
          <div className="menu-box">
            <Nav className="rb-tabs hk-tabs-col nav-tabs">
              {TabsMenu &&
                TabsMenu.map((item) => {
                  return (
                    <React.Fragment >
                      {/* key={item.key} */}
                      <NavItem onClick={() => handleActiveTab(item)}>
                        <NavLink
                          href="#"
                          className={activeTab === item.key ? "active pe-2 " : "pe-2"}
                        >
                          <span className="d-block ps-10 validation_message" title={item.name} >{item.name}</span>

                          {activeTab === item.key && (
                            <i className="icon-Icon-awesome-check-circle"></i>
                          )}
                        </NavLink>
                      </NavItem>
                    </React.Fragment>
                  );
                })}
            </Nav>
          </div>
        </div>
        <div className="tab-content-col right_info_panel">
          <div className="d-flex gap-2 flex-column mb-2">
            <div className="d-flex align-items-center justify-content-between px-10">
              {type === 'PlanInfo' || type === 'BulkEligibity' || type === 'InstantEligibility' ? null :
                <button className="btn btn-validate d-flex align-items-center gap-1 justify-content-center" onClick={() => setShowEligibilityHistory(false)}>
                  <i className="icon-arrow-left2 fs-10" /> Back
                </button>
              }
              {eligibilityHistoryData?.Data?.[0]?.Status &&
                <div className="d-flex align-items-center gap-2">
                  {eligibilityHistoryData?.Data?.[0]?.Status === 'Active' ? <i className='pill ar-user_active'>{eligibilityHistoryData?.Data?.[0]?.Status}</i> :
                    eligibilityHistoryData?.Data?.[0]?.Status === 'InActive' ? <i className='pill ar-user_active inactive-clr'>{eligibilityHistoryData?.Data?.[0]?.Status}</i> :
                      eligibilityHistoryData?.Data?.[0]?.Status === 'Rejected' ? <i className='pill ar-user_active Rejected-by-Payer'>{eligibilityHistoryData?.Data?.[0]?.Status}</i> :
                        eligibilityHistoryData?.Data?.[0]?.Status === 'Failed' ? <div className="pill ar-user_active Partialdenied ">{eligibilityHistoryData?.Data?.[0]?.Status}</div> : <></>}
                  {eligibilityHistoryData?.Data?.[0]?.LastCheckDate &&
                    <div className="">
                      <p class="text fs-12">{eligibilityHistoryData?.Data?.[0]?.LastCheckDate || 'N/A'}</p>
                    </div>}
                </div>}
              {/* <button className="btn btn-elligible-download px-10 rounded">Download</button> */}
            </div>
            {type === 'BulkEligibity' && ListOfID.length > 1 ? <>
              <div className="d-flex align-items-center justify-content-end px-10 gap-2">
                <div className="claims-TabHeader w-auto border-0 d-block">
                  <div className="claims-TabHeader__right br-right-1 br-clr pe-2">
                    <button
                      className="btn"
                      disabled={currentIndex <= 0}
                      onClick={handlePrevious}
                    >
                      <i className="icon-Icon-ionic-md-arrow-round-back"></i>
                    </button>
                    <button
                      className="btn"
                      disabled={currentIndex >= ListOfID.length - 1}
                      onClick={handleNext}
                    >
                      <i className="icon-arrow-right"></i>
                    </button>
                  </div>
                </div>

                <span className="icon-Group-1000002858 fs-21 br-right-1 br-clr pe-2">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </span>



              </div>
            </> : null}
            {type === 'InstantEligibility' && eligibilityHistoryData?.Data?.[0]?.IsPatientCreated === 'false'?
              <div className="d-flex align-items-center justify-content-end px-10 gap-2">
                <button className="btn btn-validate rounded px-10" onClick={handleCreatePatient}>Create Patient</button>
              </div>
              : null}



            {(activeTab === 1 && eligibilityHistoryData?.Data?.[0]?.Status === 'Rejected' && eligibilityHistoryData?.Data?.[0]?.RejectionMsg) &&
              (<div className="ar_message-header">
                <p className='pill h-100 py-1 font-m Rejected-by-Payer'>Rejection Message : {eligibilityHistoryData?.Data?.[0]?.RejectionMsg}</p>
              </div>)}
          </div>
          <div className="ar-table-scroll hover-scrollbar">
            <TabContent activeTab={activeTab}>
              <TabPane tabId={1}>
                <div className="h-100 hk-payment-tabs">
                  <div className="row m-0">
                    <div className="col-md-6 p-0 mb-1">
                      <Accordion defaultExpanded>
                        <AccordionSummary
                          id="prac1-header"
                          aria-controls="prac1-content"
                          expandIcon={<ExpandMoreIcon />}
                        >
                          <p className="text font-sb text-nowrap validation_message fs-12">Subscriber Info</p>
                        </AccordionSummary>
                        <AccordionDetails>
                          {eligibilityHistoryData?.Data?.length > 0 && eligibilityHistoryData.Data.map((item) => {
                            return (
                              <div className="p-10 box-border subscriber-info ar-error_mesage-menu-left">

                                {/* <div className="row m-0">
                                  <div className="col-md-8 p-0">
                                    <div className="row m-0 g-0 row-gap-10 align-items-end">
                                      <div className="col-md-4 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Subscriber Name</p>
                                      </div>
                                      <div className="col-md-8 p-0">
                                        <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.SubscriberName} {item.SAge && `(${item.SAge})`} {item.SSex}</p>
                                      </div>
                                      <div className="col-md-4 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Address</p>
                                      </div>
                                      <div className="col-md-8 p-0">
                                        <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.SAddress}</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-4 p-0">
                                    <div className="d-flex gap-25 align-items-center">
                                      <p className="text font-sb text-nowrap validation_message fs-12">Relation</p>
                                      <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.SRelation}</p>
                                    </div>
                                  </div>
                                </div> */}

                                {/* New Design */}
                                {/* highlight background  == yellow_bg px-1 w-max-content */}
                                <div className="row m-0 row-gap-10">
                                  <div className="col-md-6 p-0">
                                    <div className="row m-0 g-0 row-gap-10 align-items-end">
                                      <div className="col-md-5 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Last Name</p>
                                      </div>
                                      <div className="col-md-7 p-0">
                                        <div className="d-flex align-items-center gap-2">
                                          <p className="text fs-11 font-m ar-light-color validation_message text-nowrap" title={item.SLastName}>{item.SLastName}</p>
                                          <div className="position-relative  d-flex">
                                            <ErrorIconAndPopup ID={item.PatientInsuranceID} isLoading={isLoading} setIsLoading={setIsLoading} setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey={'SLastName'} value={item.SLastName} sysValue={item.SysSLastName} isChange={item?.SLastNameIdentifier === "1" ? true : false} />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-5 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Middle Name</p>
                                      </div>
                                      <div className="col-md-7 p-0">
                                        <div className="d-flex align-items-center gap-2">
                                          <p className="text fs-11 font-m ar-light-color validation_message text-nowrap" title={item.SMiddle}>{item.SMiddle}</p>
                                          <div className="position-relative  d-flex">
                                            <ErrorIconAndPopup ID={item.PatientInsuranceID} isLoading={isLoading} setIsLoading={setIsLoading} setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey={'SMiddle'} value={item.SMiddle} sysValue={item.SysSMiddle} isChange={item?.SMiddleIdentifier === "1" ? true : false} />
                                            {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                            {errorMessage?.SDOB && (
                                              <div className="ar-error_mesage-menu p-1-5">
                                                <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                                <div className="d-flex justify-content-end">
                                                  <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                                </div>
                                              </div>
                                            )} */}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-5 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Gender</p>
                                      </div>
                                      <div className="col-md-7 p-0">
                                        <div className="d-flex align-items-center gap-2">
                                          <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.SSex}</p>
                                          <div className="position-relative  d-flex">
                                            <ErrorIconAndPopup ID={item.PatientInsuranceID} isLoading={isLoading} setIsLoading={setIsLoading} setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey={'SSex'} value={item.SSex} sysValue={item.SysSSex} isChange={item?.SSexIdentifier === "1" ? true : false} />
                                            {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                            {errorMessage?.SDOB && (
                                              <div className="ar-error_mesage-menu p-1-5">
                                                <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                                <div className="d-flex justify-content-end">
                                                  <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                                </div>
                                              </div>
                                            )} */}
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                  <div className="col-md-6 p-0">
                                    <div className="row m-0 g-0 row-gap-10 align-items-end">
                                      <div className="col-md-5 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">First Name</p>
                                      </div>
                                      <div className="col-md-7 p-0">
                                        <div className="d-flex align-items-center gap-2">
                                          <p className="text fs-11 font-m ar-light-color validation_message text-nowrap" title={item.SFirstName}>{item.SFirstName}</p>
                                          <div className="position-relative  d-flex">
                                            <ErrorIconAndPopup ID={item.PatientInsuranceID} isLoading={isLoading} setIsLoading={setIsLoading} setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey={'SFirstName'} value={item.SFirstName} sysValue={item.SysSFirstName} isChange={item?.SFirstNameIdentifier === "1" ? true : false} />
                                            {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                            {errorMessage?.SDOB && (
                                              <div className="ar-error_mesage-menu p-1-5">
                                                <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                                <div className="d-flex justify-content-end">
                                                  <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                                </div>
                                              </div>
                                            )} */}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-5 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">DOB</p>
                                      </div>
                                      <div className="col-md-7 p-0">
                                        <div className="d-flex align-items-center gap-2">
                                          <p className="text fs-11 font-m ar-light-color validation_message text-nowrap ">{item.SDOB}</p>
                                          <div className="position-relative  d-flex">
                                            <ErrorIconAndPopup ID={item.PatientInsuranceID} isLoading={isLoading} setIsLoading={setIsLoading} setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey={'SDOB'} value={item.SDOB} sysValue={item.SysSDOB} isChange={item?.SDOBIdentifier === "1" ? true : false} />
                                            {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                            {errorMessage?.SDOB && (
                                              <div className="ar-error_mesage-menu p-1-5">
                                                <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                                <div className="d-flex justify-content-end">
                                                  <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                                </div>
                                              </div>
                                            )} */}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-5 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Subscriber ID</p>
                                      </div>
                                      <div className="col-md-7 p-0">
                                        <div className="d-flex align-items-center gap-2">
                                          <p className="text fs-11 font-m ar-light-color validation_message text-nowrap" title={item.SID}>{item.SID}</p>
                                          <div className="position-relative  d-flex">
                                            <ErrorIconAndPopup ID={item.PatientInsuranceID} isLoading={isLoading} setIsLoading={setIsLoading} setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey={'SID'} value={item.SID} sysValue={item.SysSID} isChange={item?.SIDIdentifier === "1" ? true : false} />
                                            {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                            {errorMessage?.SDOB && (
                                              <div className="ar-error_mesage-menu p-1-5">
                                                <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                                <div className="d-flex justify-content-end">
                                                  <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                                </div>
                                              </div>
                                            )} */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="w-20 p-0">
                                    <p className="text font-sb text-nowrap validation_message fs-12">Address</p>
                                  </div>
                                  <div className="col-md-9 pe-0 ps-1">
                                    <div className="d-flex align-items-center gap-2">
                                      <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.SAddress}</p>
                                      <div className="position-relative  d-flex">
                                        <ErrorIconAndPopup ID={item.PatientInsuranceID} isLoading={isLoading} setIsLoading={setIsLoading} setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey={'SAddress'} value={item.SAddress} sysValue={item.SysSAddress} isChange={item?.SAddressIdentifier === "1" ? true : false} />
                                        {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                        {errorMessage?.SDOB && (
                                          <div className="ar-error_mesage-menu p-1-5">
                                            <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                            <div className="d-flex justify-content-end">
                                              <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                            </div>
                                          </div>
                                        )} */}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row m-0 g-0">
                                    <div className="col-md-6 p-0 row m-0 g-0">
                                      <div className="col-md-5 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Group #</p>
                                      </div>
                                      <div className="col-md-7 p-0">
                                        <div className="d-flex align-items-center gap-2">
                                          <p className="text fs-11 font-m ar-light-color validation_message text-nowrap" title={item.SGroup}>{item.SGroup}</p>
                                          <div className="position-relative  d-flex">
                                            {/* <ErrorIconAndPopup ID = {item.PatientInsuranceID} isLoading={isLoading} setIsLoading = {setIsLoading}setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey = {'SGroup'} value = {item.SGroup} sysValue={item.SysSGroup} isChange = {item?.SGroupIdentifier === "1" ? true : false}/> */}
                                            {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                        {errorMessage?.SDOB && (
                                          <div className="ar-error_mesage-menu p-1-5">
                                            <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                            <div className="d-flex justify-content-end">
                                              <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                            </div>
                                          </div>
                                        )} */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-6 p-0 row m-0 g-0">
                                      <div className="col-md-5 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Prior Identifier #</p>
                                      </div>
                                      <div className="col-md-7 p-0">
                                        <div className="d-flex align-items-center gap-2">
                                          <p className="text fs-11 font-m ar-light-color validation_message text-nowrap" title={item.PriorIdentifierNumber}>{item.PriorIdentifierNumber}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="w-20 p-0">
                                    <p className="text font-sb text-nowrap validation_message fs-12">Plan Date</p>
                                  </div>
                                  <div className="col-md-9 pe-0 ps-1">
                                    <div className="d-flex align-items-center gap-2">
                                      <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.SPlanDate}</p>
                                      <div className="position-relative  d-flex">
                                        {/* <ErrorIconAndPopup ID = {item.PatientInsuranceID} isLoading={isLoading} setIsLoading = {setIsLoading}setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey = {'SPlanDate'} value = {item.SPlanDate} isChange = {item?.SPlanDateIdentifier === "1" ? true : false}/> */}
                                        {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                        {errorMessage?.SDOB && (
                                          <div className="ar-error_mesage-menu p-1-5">
                                            <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                            <div className="d-flex justify-content-end">
                                              <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                            </div>
                                          </div>
                                        )} */}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="w-20 p-0">
                                    <p className="text font-sb text-nowrap validation_message fs-12">Eligibility Date</p>
                                  </div>
                                  <div className="col-md-9 pe-0 ps-1">
                                    <div className="d-flex align-items-center gap-2">
                                      <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.SEligibilityDate}</p>
                                      <div className="position-relative  d-flex">
                                        {/* <ErrorIconAndPopup ID = {item.PatientInsuranceID} isLoading={isLoading} setIsLoading = {setIsLoading}setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey = {'SEligibilityDate'} value = {item.SEligibilityDate} isChange = {item?.SEligibilityDateIdentifier === "1" ? true : false}/> */}
                                        {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                        {errorMessage?.SDOB && (
                                          <div className="ar-error_mesage-menu p-1-5">
                                            <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                            <div className="d-flex justify-content-end">
                                              <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                            </div>
                                          </div>
                                        )} */}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            );
                          })}
                        </AccordionDetails>
                      </Accordion>
                    </div>
                    <div className="col-md-6 pe-0 ps-2px mb-1">
                      <Accordion defaultExpanded>
                        <AccordionSummary
                          id="prac1-header"
                          aria-controls="prac1-content"
                          expandIcon={<ExpandMoreIcon />}
                        >
                          <p className="heading fs-12">Patient Info</p>
                        </AccordionSummary>
                        <AccordionDetails>
                          {eligibilityHistoryData?.Data?.length > 0 && eligibilityHistoryData.Data.map((item) => {
                            return (


                              <div className="p-10 box-border">
                                {/* <div className="row m-0">
                                  <div className="col-md-8 p-0">
                                    <div className="row m-0 g-0 row-gap-10 align-items-end">
                                      <div className="col-md-4 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Patient Name</p>
                                      </div>
                                      <div className="col-md-8 p-0">
                                        <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.PatientName} {item.PAge && `(${item.PAge})`} {item.PSex}</p>
                                      </div>
                                      <div className="col-md-4 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Address</p>
                                      </div>
                                      <div className="col-md-8 p-0">
                                        <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.PAddress}</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-4 p-0">
                                    <div className="d-flex gap-25 align-items-center">
                                      <p className="text font-sb text-nowrap validation_message fs-12">Relation</p>
                                      <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.PRelation}</p>
                                    </div>
                                  </div>
                                </div> */}

                                {/* New Design */}

                                <div className="row m-0 row-gap-10">
                                  <div className="col-md-6 p-0">
                                    <div className="row m-0 g-0 row-gap-10 align-items-end">
                                      <div className="col-md-5 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Last Name</p>
                                      </div>
                                      <div className="col-md-7 p-0">
                                        <div className="col-md-9 pe-0 ps-1">
                                          <div className="d-flex align-items-center gap-2">
                                            <p className="text fs-11 font-m ar-light-color validation_message text-nowrap" title={item.PLastName}>{item.PLastName}</p>
                                            <div className="position-relative  d-flex">
                                              {/* <ErrorIconAndPopup ID = {item.PatientInsuranceID} isLoading={isLoading} setIsLoading = {setIsLoading}setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey = {'PLastName'} value = {item.PLastName} isChange = {item?.PLastNameIdentifier === "1" ? true : false}/> */}
                                              {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                              {errorMessage?.SDOB && (
                                                <div className="ar-error_mesage-menu p-1-5">
                                                  <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                                  <div className="d-flex justify-content-end">
                                                    <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                                  </div>
                                                </div>
                                              )} */}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-5 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Middle Name</p>
                                      </div>
                                      <div className="col-md-7 p-0">
                                        <div className="d-flex align-items-center gap-2">
                                          <p className="text fs-11 font-m ar-light-color validation_message text-nowrap" title={item.PMiddle}>{item.PMiddle}</p>
                                          <div className="position-relative  d-flex">
                                            {/* <ErrorIconAndPopup ID = {item.PatientInsuranceID} isLoading={isLoading} setIsLoading = {setIsLoading}setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey = {'PMiddle'} value = {item.PMiddle} isChange = {item?.PMiddleIdentifier === "1" ? true : false}/> */}
                                            {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                            {errorMessage?.SDOB && (
                                              <div className="ar-error_mesage-menu p-1-5">
                                                <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                                <div className="d-flex justify-content-end">
                                                  <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                                </div>
                                              </div>
                                            )} */}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-5 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Gender</p>
                                      </div>
                                      <div className="col-md-7 p-0">
                                        <div className="d-flex align-items-center gap-2">
                                          <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.PSex}</p>
                                          <div className="position-relative  d-flex">
                                            {/* <ErrorIconAndPopup ID = {item.PatientInsuranceID} isLoading={isLoading} setIsLoading = {setIsLoading}setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey = {'PSex'} value = {item.PSex} isChange = {item?.PSexIdentifier === "1" ? true : false}/> */}
                                            {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                            {errorMessage?.SDOB && (
                                              <div className="ar-error_mesage-menu p-1-5">
                                                <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                                <div className="d-flex justify-content-end">
                                                  <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                                </div>
                                              </div>
                                            )} */}
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                  <div className="col-md-6 p-0">
                                    <div className="row m-0 g-0 row-gap-10 align-items-end">
                                      <div className="col-md-5 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">First Name</p>
                                      </div>
                                      <div className="col-md-7 p-0">
                                        <div className="d-flex align-items-center gap-2">
                                          <p className="text fs-11 font-m ar-light-color validation_message text-nowrap" title={item.PFirstName}>{item.PFirstName}</p>
                                          <div className="position-relative  d-flex">
                                            {/* <ErrorIconAndPopup ID = {item.PatientInsuranceID} isLoading={isLoading} setIsLoading = {setIsLoading}setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey = {'PFirstName'} value = {item.PFirstName} isChange = {item?.PFirstNameIdentifier === "1" ? true : false}/> */}
                                            {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                            {errorMessage?.SDOB && (
                                              <div className="ar-error_mesage-menu p-1-5">
                                                <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                                <div className="d-flex justify-content-end">
                                                  <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                                </div>
                                              </div>
                                            )} */}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-5 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">DOB</p>
                                      </div>
                                      <div className="col-md-7 p-0">
                                        <div className="d-flex align-items-center gap-2">
                                          <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.PDOB}</p>
                                          <div className="position-relative  d-flex">
                                            {/* <ErrorIconAndPopup ID = {item.PatientInsuranceID} isLoading={isLoading} setIsLoading = {setIsLoading}setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey = {'PDOB'} value = {item.PDOB} isChange = {item?.PDOBIdentifier === "1" ? true : false}/> */}
                                            {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                            {errorMessage?.SDOB && (
                                              <div className="ar-error_mesage-menu p-1-5">
                                                <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                                <div className="d-flex justify-content-end">
                                                  <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                                </div>
                                              </div>
                                            )} */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="w-20 p-0">
                                    <p className="text font-sb text-nowrap validation_message fs-12">Address</p>
                                  </div>
                                  <div className="col-md-9 pe-0 ps-1">
                                    <div className="d-flex align-items-center gap-2">
                                      <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.PAddress}</p>
                                      <div className="position-relative  d-flex">
                                        {/* <ErrorIconAndPopup ID = {item.PatientInsuranceID} isLoading={isLoading} setIsLoading = {setIsLoading}setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey = {'PAddress'} value = {item.PAddress} isChange = {item?.PAddressIdentifier === "1" ? true : false}/> */}
                                        {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                        {errorMessage?.SDOB && (
                                          <div className="ar-error_mesage-menu p-1-5">
                                            <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                            <div className="d-flex justify-content-end">
                                              <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                            </div>
                                          </div>
                                        )} */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </AccordionDetails>
                      </Accordion>
                      <Accordion defaultExpanded>
                        <AccordionSummary
                          id="prac1-header"
                          aria-controls="prac1-content"
                          expandIcon={<ExpandMoreIcon />}
                        >
                          <p className="heading fs-12">Provider Info</p>
                        </AccordionSummary>
                        <AccordionDetails>
                          {eligibilityHistoryData?.Data?.length > 0 && eligibilityHistoryData.Data.map((item) => {
                            return (
                              <div className="p-10 box-border">
                                <div className="row m-0  row-gap-10">
                                  <div className="col-md-6 p-0">
                                    <div className="row m-0 g-0 row-gap-10 align-items-end">
                                      <div className="col-md-5 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Name</p>
                                      </div>
                                      <div className="col-md-7 p-0">
                                        <div className="d-flex align-items-center gap-2">
                                          <p className="text fs-11 font-m ar-light-color validation_message text-nowrap" title={item.ProviderName}>{item.ProviderName}</p>
                                          <div className="position-relative  d-flex">
                                            {/* <ErrorIconAndPopup ID = {item.PatientInsuranceID} isLoading={isLoading} setIsLoading = {setIsLoading}setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey = {'ProviderName'} value = {item.ProviderName} isChange = {item?.ProviderNameIdentifier === "1" ? true : false}/> */}
                                            {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                            {errorMessage?.SDOB && (
                                              <div className="ar-error_mesage-menu p-1-5">
                                                <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                                <div className="d-flex justify-content-end">
                                                  <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                                </div>
                                              </div>
                                            )} */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6 p-0">
                                    <div className="row m-0 g-0 row-gap-10 align-items-end">
                                      <div className="col-md-5 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">NPI</p>
                                      </div>
                                      <div className="col-md-7 p-0">
                                        <div className="d-flex align-items-center gap-2">
                                          <p className="text fs-11 font-m ar-light-color validation_message text-nowrap" title={item.ProviderNPI}>{item.ProviderNPI}</p>
                                          <div className="position-relative  d-flex">
                                            {/* <ErrorIconAndPopup ID = {item.PatientInsuranceID} isLoading={isLoading} setIsLoading = {setIsLoading}setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey = {'ProviderNPI'} value = {item.ProviderNPI} isChange = {item?.ProviderNPIIdentifier === "1" ? true : false}/> */}
                                            {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                            {errorMessage?.SDOB && (
                                              <div className="ar-error_mesage-menu p-1-5">
                                                <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                                <div className="d-flex justify-content-end">
                                                  <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                                </div>
                                              </div>
                                            )} */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="w-20 p-0">
                                    <p className="text font-sb text-nowrap validation_message fs-12">Taxonomy</p>
                                  </div>
                                  <div className="col-md-9 pe-0 ps-1">
                                    <div className="d-flex align-items-center gap-2">
                                      <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.ProviderTaxonomyCode}</p>
                                      <div className="position-relative  d-flex">
                                        {/* <ErrorIconAndPopup ID = {item.PatientInsuranceID} isLoading={isLoading} setIsLoading = {setIsLoading}setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey = {'ProviderTaxonomyCode'} value = {item.ProviderTaxonomyCode} isChange = {item?.ProviderTaxonomyCodeIdentifier === "1" ? true : false}/> */}
                                        {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                        {errorMessage?.SDOB && (
                                          <div className="ar-error_mesage-menu p-1-5">
                                            <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                            <div className="d-flex justify-content-end">
                                              <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                            </div>
                                          </div>
                                        )} */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </AccordionDetails>
                      </Accordion>
                    </div>
                    <div className="col-md-12 p-0">
                      <Accordion defaultExpanded>
                        <AccordionSummary
                          id="prac1-header"
                          aria-controls="prac1-content"
                          expandIcon={<ExpandMoreIcon />}
                        >
                          <p className="text font-sb text-nowrap validation_message fs-12">Payer Info</p>
                        </AccordionSummary>
                        <AccordionDetails>
                          {eligibilityHistoryData?.Data?.length > 0 && eligibilityHistoryData.Data.map((item) => {
                            return (
                              <div className="p-10 box-border ar-error_mesage-menu-left">

                                {/* <div className="row m-0">
                                  <div className="col-md-12 p-0">
                                    <div className="row m-0 g-0 row-gap-10 align-items-end">
                                      <div className="col-md-6 p-0">
                                        <div className="row m-0 g-0 align-items-end">
                                          <div className="col-md-4 p-0">
                                            <p className="text font-sb text-nowrap validation_message fs-12">Payer Name</p>
                                          </div>
                                          <div className="col-md-8 p-0">
                                            <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.PayerName}</p>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-6 p-0">
                                        <div className="row m-0 g-0 align-items-end">
                                          <div className="col-md-4 p-0">
                                            <p className="text font-sb text-nowrap validation_message fs-12">Contact #</p>
                                          </div>
                                          <div className="col-md-8 p-0">
                                            <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.PayerContactNo}</p>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="w-20 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Website</p>
                                      </div>
                                      <div className="col-md-9 pe-0 ps-1">
                                        <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.PayerWebsite}</p>
                                      </div>
                                      <div className="w-20 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Plan Name</p>
                                      </div>
                                      <div className="col-md-9 pe-0 ps-1">
                                        <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.PlanName}</p>
                                      </div>
                                      <div className="col-md-6 p-0">
                                        <div className="row m-0 g-0 align-items-end">
                                          <div className="col-md-4 p-0">
                                            <p className="text font-sb text-nowrap validation_message fs-12">Plan</p>
                                          </div>
                                          <div className="col-md-8 p-0">
                                            <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.PlanEndDate ? `${item.PlanStartDate} - ${item.PlanEndDate}` : item.PlanStartDate}</p>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-6 p-0">
                                        <div className="row m-0 g-0 align-items-end">
                                          <div className="col-md-4 p-0">
                                            <p className="text font-sb text-nowrap validation_message fs-12">Eligibility Date</p>
                                          </div>
                                          <div className="col-md-8 p-0">
                                            <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.EligibilityDate}</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                </div> */}

                                {/* New Design */}

                                <div className="row m-0 row-gap-10">
                                  <div className="col-md-4 p-0">
                                    <div className="row m-0 g-0 row-gap-10 align-items-end">
                                      <div className="col-md-5 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Payer Name</p>
                                      </div>
                                      <div className="col-md-7 p-0">
                                        <div className="d-flex align-items-center gap-2">
                                          <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.PayerName}</p>
                                          <div className="position-relative  d-flex">
                                            {/* <ErrorIconAndPopup ID = {item.PatientInsuranceID} isLoading={isLoading} setIsLoading = {setIsLoading}setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey = {'PayerName'} value = {item.PayerName} isChange = {item?.PayerNameIdentifier === "1" ? true : false}/> */}
                                            {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                            {errorMessage?.SDOB && (
                                              <div className="ar-error_mesage-menu p-1-5">
                                                <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                                <div className="d-flex justify-content-end">
                                                  <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                                </div>
                                              </div>
                                            )} */}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-5 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Website</p>
                                      </div>
                                      <div className="col-md-7 p-0">
                                        <div className="d-flex align-items-center gap-2">
                                          <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.PayerWebsite}</p>
                                          <div className="position-relative  d-flex">
                                            {/* <ErrorIconAndPopup ID = {item.PatientInsuranceID} isLoading={isLoading} setIsLoading = {setIsLoading}setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey = {'PayerWebsite'} value = {item.PayerWebsite} isChange = {item?.PayerWebsiteIdentifier === "1" ? true : false}/> */}
                                            {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                            {errorMessage?.SDOB && (
                                              <div className="ar-error_mesage-menu p-1-5">
                                                <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                                <div className="d-flex justify-content-end">
                                                  <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                                </div>
                                              </div>
                                            )} */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-4 p-0">
                                    <div className="row m-0 g-0 row-gap-10 align-items-end">
                                      <div className="col-md-5 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Payer ID</p>
                                      </div>
                                      <div className="col-md-7 p-0">
                                        <div className="d-flex align-items-center gap-2">
                                          <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.PayerID}</p>
                                          <div className="position-relative  d-flex">
                                            {/* <ErrorIconAndPopup ID = {item.PatientInsuranceID} isLoading={isLoading} setIsLoading = {setIsLoading}setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey = {'PayerID'} value = {item.PayerID} isChange = {item?.PayerIDIdentifier === "1" ? true : false}/> */}
                                            {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                            {errorMessage?.SDOB && (
                                              <div className="ar-error_mesage-menu p-1-5">
                                                <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                                <div className="d-flex justify-content-end">
                                                  <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                                </div>
                                              </div>
                                            )} */}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-5 p-0">
                                        <p className="text font-sb text-nowrap validation_message fs-12">Contact #</p>
                                      </div>
                                      <div className="col-md-7 p-0">
                                        <div className="d-flex align-items-center gap-2">
                                          <p className="text fs-11 font-m ar-light-color validation_message text-nowrap">{item.PayerContactNo}</p>
                                          <div className="position-relative  d-flex">
                                            {/* <ErrorIconAndPopup ID = {item.PatientInsuranceID} isLoading={isLoading} setIsLoading = {setIsLoading}setIsRecordSaved={setIsRecordSaved} errorMessage={errorMessage} setErrorMessage={setErrorMessage} itemKey = {'PayerContactNo'} value = {item.PayerContactNo} isChange = {item?.PayerContactNoIdentifier === "1" ? true : false}/> */}
                                            {/* <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={() => handleError('SDOB')}></i>
                                            {errorMessage?.SDOB && (
                                              <div className="ar-error_mesage-menu p-1-5">
                                                <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({item.SDOB})</span> doesn’t match.</p>
                                                <div className="d-flex justify-content-end">
                                                  <button className="btn btn-orange fs-11 h-100 px-2 rounded">Update in System </button>
                                                </div>
                                              </div>
                                            )} */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </AccordionDetails>
                      </Accordion>
                    </div>

                    {/* <div className="col-md-6 pe-0 ps-2px">
                      <Accordion defaultExpanded>
                        <AccordionSummary
                          id="prac1-header"
                          aria-controls="prac1-content"
                          expandIcon={<ExpandMoreIcon />}
                        >
                          <p className="heading fs-12">Other Info</p>
                        </AccordionSummary>
                        <AccordionDetails>
                          {eligibilityHistoryData?.Data?.length > 0 && eligibilityHistoryData.Data.map((item) => {
                            return (
                              // <div className="hk-payment-flex">
                              //   <div class="list-info">
                              //     <div className="item">
                              //       <div className="title wide">Group Number:</div>
                              //       <div className="value">{item.GroupNumber}</div>
                              //     </div>
                              //     <div className="item">
                              //       <div className="title wide">Group Name:</div>
                              //       <div className="value">{item.GroupName}</div>
                              //     </div>
                              //     <div className="item">
                              //       <div className="title wide">Policy Name:</div>
                              //       <div className="value">{item.PolicyName}</div>
                              //     </div>
                              //   </div>
                              //   <div class="list-info">
                              //     <div className="item">
                              //       <div className="title wide">Policy Number:</div>
                              //       <div className="value">{item.PolicyNumber}</div>
                              //     </div>
                              //     <div className="item">
                              //       <div className="title wide">Service Type:</div>
                              //       <div className="value">{item.ServiceType}</div>
                              //     </div>
                              //   </div>
                              // </div>
                              <div className="p-10 box-border">
                                <div className="row m-0">
                                  <div className="col-md-12 p-0">
                                    <div className="row m-0 g-0 row-gap-10 align-items-end">
                                      <div className="col-md-4 p-0">
                                        <p className="heading fs-12">Group Name</p>
                                      </div>
                                      <div className="col-md-8 p-0">
                                        <p className="text fs-11 font-m ar-light-color">{item.GroupName} {item.GroupNumber && (item.GroupNumber)}</p>
                                      </div>
                                      <div className="col-md-4 p-0">
                                        <p className="heading fs-12">Policy Name</p>
                                      </div>
                                      <div className="col-md-8 p-0">
                                        <p className="text fs-11 font-m ar-light-color">{item.PolicyName} {item.PolicyNumber && (item.PolicyNumber)}</p>
                                      </div>
                                      <div className="col-md-4 p-0">
                                        <p className="heading fs-12">Service Type</p>
                                      </div>
                                      <div className="col-md-8 p-0">
                                        <p className="text fs-11 font-m ar-light-color">{item.ServiceType}</p>
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            );
                          })}
                        </AccordionDetails>
                      </Accordion>
                    </div> */}
                  </div>
                </div>
              </TabPane>
              {eligibilityHistoryData?.Data?.[0]?.ChildData?.length > 0 &&
                <>
                  <TabPane tabId={2}>
                    <EligiblityHistoryStatusTabs columns={TabCol} data={eligibilityHistoryData?.Data?.[0]?.ChildData} type={"Active Coverage"} />
                  </TabPane>
                  <TabPane tabId={3}>
                    <EligiblityHistoryStatusTabs columns={TabCol} data={eligibilityHistoryData?.Data?.[0]?.ChildData} type={"Co-Insurance"} />
                  </TabPane>
                  <TabPane tabId={4}>
                    <EligiblityHistoryStatusTabs columns={TabCol} data={eligibilityHistoryData?.Data?.[0]?.ChildData} type={"Co-Payment"} />
                  </TabPane>
                  <TabPane tabId={5}>
                    <EligiblityHistoryStatusTabs columns={TabCol} data={eligibilityHistoryData?.Data?.[0]?.ChildData} type={"Deductible"} />
                  </TabPane>
                  <TabPane tabId={6}>
                    <EligiblityHistoryStatusTabs columns={TabCol} data={eligibilityHistoryData?.Data?.[0]?.ChildData} type={"Out of Pocket (Stop Loss)"} />
                  </TabPane>
                  <TabPane tabId={7}>
                    <EligiblityHistoryStatusTabs columns={TabCol} data={eligibilityHistoryData?.Data?.[0]?.ChildData} type={"Limitations"} />
                  </TabPane>
                  <TabPane tabId={8}>
                    <EligiblityHistoryStatusTabs columns={TabCol} data={eligibilityHistoryData?.Data?.[0]?.ChildData} type={"Others"} />
                  </TabPane>
                  <TabPane tabId={9}>
                    <EligiblityHistoryStatusTabs columns={TabCol} data={eligibilityHistoryData?.Data?.[0]?.ChildData} type={"Inactive"} />
                  </TabPane>
                  <TabPane tabId={10}>
                    <EligiblityHistoryStatusTabs columns={TabCol} data={eligibilityHistoryData?.Data?.[0]?.ChildData} type={"Non-Covered"} />
                  </TabPane>
                  <TabPane tabId={11}>
                    <EligiblityHistoryStatusTabs columns={TabCol} data={eligibilityHistoryData?.Data?.[0]?.ChildData} type={"Benefit Description"} />
                  </TabPane>
                  <TabPane tabId={12}>
                    <EligiblityHistoryStatusTabs columns={TabCol} data={eligibilityHistoryData?.Data?.[0]?.ChildData} type={"Active - Pending Investigation"} />
                  </TabPane>
                  <TabPane tabId={13}>
                    <EligiblityHistoryStatusTabs columns={TabCol} data={eligibilityHistoryData?.Data?.[0]?.ChildData} type={"Primary Care Provider"} />
                  </TabPane>
                  <TabPane tabId={14}>
                    <EligiblityHistoryStatusTabs columns={TabCol} data={eligibilityHistoryData?.Data?.[0]?.ChildData} type={"Other or Additional Payor"} />
                  </TabPane>




                </>}
            </TabContent>
          </div >
        </div >
      </div >
    </div >
  );
};

export default EligiblityHistoryStatus;


// console.log("Toggling error Message",errorMessage);
const ErrorIconAndPopup = ({ ID, setIsRecordSaved, setIsLoading, itemKey, value, sysValue, isChange, errorMessage, setErrorMessage }) => {

  const API_URL_GENERAL = enumUtil.controller.General;
  const handleError = (e, itemKey) => {
    e.stopPropagation();
    setErrorMessage(prev => ({ [itemKey]: !prev?.[itemKey] }))
  }

  const closeDropdown = () => {
    setErrorMessage({});
  };

  const handleSave = async () => {
    let saveModal = {
      TableName: enumUtil.enumAPITableName.EligibilityData,
      ID: ID,
      Data: { [itemKey]: value },
    }
    setIsLoading(true)
    closeDropdown();
    ServerRequestProtected(API_URL_GENERAL + "/SaveSingleRecord", 'post', saveModal)
      .then((response) => {
        if (!isNull(response.id)) {
          setIsLoading(false)
          // NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success)
          setIsRecordSaved(true);
        }
      }).catch((error) => {
        setIsLoading(false)
        console.log('error', error);
        NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
      })
  }

  console.log("Toggling error for ErrorIconAndPopup:", itemKey); // Debugging
  return (
    <>
      {/* {isLoading ? <Loader /> : null} */}
      {isChange && <i className="bi bi-info-circle-fill fs-12 Denied-clr" onClick={(e) => handleError(e, itemKey)}></i>}
      {errorMessage?.[itemKey] &&
        <CustomUseRef onClose={closeDropdown} IsActivePtPayments={errorMessage?.[itemKey]}>
          <div className="ar-error_mesage-menu p-1-5">
            <p className="red-box text fs-10 text-nowrap mb-06-px">Data <span className="Denied-clr font-m">({sysValue})</span> doesn’t match.</p>
            <div className="d-flex justify-content-end">
              <button className="btn btn-orange fs-11 h-100 px-2 rounded" onClick={handleSave}>Update in System </button>
            </div>
          </div>
        </CustomUseRef>
      }
    </>)
}